import { IStatsState } from './types';

export const initialState: IStatsState = {
  projectStats: {},
  sessionStats: {},
};
